export default __webpack_public_path__ + "static/media/Screenshot_1.c59bed27.png";